import type { TruckGatepassFormData } from "@features/gatepass/schema/truckGatepassFormSchema";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const defaultValues: TruckGatepassFormData = {
  SCStatus: "",
  securityClearanceSerial: "",
  securityClearanceId: "",
  securityClearanceValidity: "",
  securityClearanceFott: "",
  gatepassCategory: "TRUCK",
  truckType: "TRUCK",
  // Job Details
  destinationVcn: "",
  vesselName: "",
  serviceNumber: "",
  cargoHandlingParty: "",
  jobNumber: "",
  jobDescription: "",
  jobStartDate: "",
  jobEndDate: "",
  // Visitor Details
  passportNumber: "",
  emiratesIdNumber: "",
  fullName: "",
  nationality: "",
  passportNumberExpirationDate: "",
  driverLicenseNumber: "",
  phoneNumber: "",
  sponsorCompany: "",
  expectedEntryDate: "",
  port: "",
  gate: "",
  visitorCompanyEnglish: "",
  visitorCompanyArabic: "",
  reference: "",
  // Gatepass Details
  gatepassType: "single",
  vip: null,
  requestFor: "entry",
  cargoDestination: "",
  gatepassDuration: "daily",
  permanentDuration: "1",
  entryType: "single",
  FOTTEntry: null,
  isFottDisabled: false,
  cargos: [
    {
      cargoType: "",
      cargo: "",
      hazardCargo: false,
      quantity: "",
      unitOfMeasurement: "",
    },
  ],
  deliveryNotesDocuments: [],
  // Vehicle Details
  vehicles: [
    {
      registrationEmirate: "Fujairah",
      vehicleType: "",
      vehicleColour: "",
      category: "",
      plateNumber: "",
      drivers: [
        {
          driverLicenseNumber: "",
          fullName: "",
          passportNumber: "",
          emiratesIdNumber: "",
          mobileNumber: "",
          securityClearanceId: "",
          securityClearanceValidity: "",
          securityClearanceFott: "",
        },
      ],
    },
  ],
  groupMembers: [],
  // Photo
  photoUrl: "",
};

type TruckGatepassStoreData = typeof defaultValues;

interface TruckGatepassFormState extends TruckGatepassStoreData {
  setField<K extends keyof TruckGatepassStoreData>(key: K, val: TruckGatepassStoreData[K]): void;
  setAll(data: Partial<TruckGatepassStoreData>): void;
  resetForm(): void;
}

export const useTruckGatepassFormStore = create<TruckGatepassFormState>()(
  persist(
    (set) => ({
      ...defaultValues,
      setField: <K extends keyof TruckGatepassStoreData>(key: K, val: TruckGatepassStoreData[K]) =>
        set((state) => ({ ...state, [key]: val })),
      setAll: (data: Partial<TruckGatepassStoreData>) => set((state) => ({ ...state, ...data })),
      resetForm: () => set(() => ({ ...defaultValues })),
    }),
    { name: "truck-gatepass-form" },
  ),
);
